import { render, staticRenderFns } from "./QuoteBuilderOtherLabourItem.vue?vue&type=template&id=4567f126"
import script from "./QuoteBuilderOtherLabourItem.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderOtherLabourItem.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderOtherLabourItem.vue?vue&type=style&index=0&id=4567f126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports